var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "970 1057 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#6c8ce4}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1132.5,1120.91v-20.74l4.98.56c1.68.19,3.15-1.13,3.15-2.82v-6.71l-57.31-6.38v-7.52l17.99,2.42v-13.78c0-1.43-1.06-2.63-2.48-2.81l-25.33-3.19v24.88l-57.28,6.38v6.71c0,1.69,1.47,3,3.15,2.82l4.67-.52v20.74l-50.4,5.97v6.69c0,1.7,1.48,3.01,3.17,2.81l4.1-.49v134.44h194.98v-134.44l3.91.46c1.69.2,3.17-1.12,3.17-2.81v-6.69l-50.47-5.98ZM1018.38,1260.56h-21.98c-3.13,0-5.67-2.54-5.67-5.67v-115.06c0-2.87,2.15-5.29,5-5.63l21.98-2.62c3.37-.4,6.34,2.23,6.34,5.63v117.68c0,3.13-2.54,5.67-5.67,5.67ZM1117.02,1260.56h-22.08c-3.13,0-5.67-2.54-5.67-5.67v-29.94c0-3.13-2.54-5.67-5.67-5.67h-10.56c-3.13,0-5.67,2.54-5.67,5.67v29.94c0,3.13-2.54,5.67-5.67,5.67h-22.17c-3.13,0-5.67-2.54-5.67-5.67v-150.71c0-2.89,2.17-5.32,5.05-5.63l37.19-4.12h4.42l37.13,4.12c2.87.32,5.04,2.75,5.04,5.63v150.71c0,3.13-2.54,5.67-5.67,5.67ZM1160.41,1260.56h-22.24c-3.13,0-5.67-2.54-5.67-5.67v-117.71c0-3.4,2.97-6.03,6.34-5.63l22.24,2.65c2.85.34,5,2.76,5,5.63v115.06c0,3.13-2.54,5.67-5.67,5.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 999.86,
    y: 1143.75,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 999.86,
    y: 1181.44,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 999.86,
    y: 1219.24,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1044.89,
    y: 1143.96,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1044.89,
    y: 1181.6,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1044.89,
    y: 1106.32,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1097.44,
    y: 1143.96,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1097.44,
    y: 1181.6,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1097.44,
    y: 1106.32,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1071.17,
    y: 1143.96,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1071.17,
    y: 1181.6,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1071.17,
    y: 1106.32,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1099.5,
    y: 1219.24,
    width: 12.62,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1044.89,
    y: 1219.24,
    width: 12.62,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1141.65,
    y: 1143.75,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1141.65,
    y: 1181.44,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1141.65,
    y: 1219.24,
    width: 14.68,
    height: 25.24,
    rx: 2.83,
    ry: 2.83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school_icon.b1735cfbe1a0fee23fc6becafbe29249.svg";
export { ForwardRef as ReactComponent };